import React, { ReactNode } from "react";
import { RouteComponentProps } from "@reach/router";
import indexService, {
  IEnterList,
  IUserCenterParams,
  IPostCreateTempDetail,
  IFeedDetailView,
  IRouteListItem,
  IMedalInfo,
  IUserinfo,
  IRewardItem,
  IResponse,
} from "../service/Index";
import styles from "../styles/index";
import update from "immutability-helper";
import { ActivityInfoCard } from "./components/ActivityInfoCard";
import ClubActivityRule from "../components/Index/ClubActivityRule";
import ClubActivityGoal from "./components/SignalGoalSelector";
import ClubActivityTopic from "./components/TopicModule";
import ClubActivitySportRecord from "./components/SportRecordModule";
import ClubActivityCertModal from "../components/Index/ClubActivityCertModal";
import Modal from "../components/Common/Modal/Modal";
import { RewardModal } from "../components/Index/RewardModal";
import { LOCAL_STORAGE_ADDRESS_KEY } from "../constants/address";
import ProgressCard from "./components/ProgressCard";
import day from "../utils/day";
import { Dayjs } from "dayjs";
import { findIndex, isEmpty, map } from "lodash";
import {
  checkIsFinishOneGoal,
  findMyGoal,
  findTempGoalConf,
  getGoals,
  getGoalState,
} from "./utils";
import { TIME_FORMATTER } from "../constants/time";
import FooterBtn from "./components/FooterBtn";
import { SystemFun, FunctionFun, Login, ImageFun } from "codoon-fun";
import { openCodoon } from "open-codoon";
import { ISportType, ISportTypeInfo } from "./interface";
import memoizeOne from "memoize-one";
import SportTypeSelector from "./components/SportTypeSelector";
import {
  shareDefaultTop,
  wxShareConfig,
  addNativeReturnListener,
  isInCodoon,
} from "../utils/bridge";
import "./index.less";
import classNames from "classnames";
import { isIosBangsDevice } from "../utils/system";
import {
  IActivityInfo,
  IAddressDatum,
  IGetGamblingCountData,
  IGoal,
} from "../service/activity/interface";
import ActivityApi from "../service/activity";
import {
  setActivityInfoAction,
  setActivityInfoLoadingAction,
  setGamblingInfoAction,
  setMedalsAction,
  setTempDetailAction,
} from "../store/common/action";
import { connect } from "react-redux";
import {
  activityIdSelector,
  activityInfoLoadingSelector,
  activityInfoSelector,
  gamblingPriceSelector,
  isGamblingSelector,
  medalsSelector,
  tempDetailSelector,
} from "../store/common/selector";
import GamblingPriceModule from "./components/GamblingPriceModule";
import GamblingFailModal from "./components/GamblingEndModal/FailModal";
import GamblingSuccessModal from "./components/GamblingEndModal/SuccessModal";
import GamblingRefundModal from "./components/GamblingEndModal/AlreadyRefundModal";

import SignRewardModule from "./components/SignRewardModule";
import ProgressRewardModule from "./components/ProgressRewardModule";

import { NewUserRewardModal } from "../components/Index/NewUserRewardModal";

import axios from "../service/api";

import { Toast, Loading } from "codoon-come";
import OtherRewardModal, {
  IOtherRewardModalConf,
} from "../components/Index/OtherRewardModal";
import InfoModal from "./components/InfoModal";
import vconsole from "vconsole";

const { showToast, GlobalToast } = Toast;
const { GlobalLoading } = Loading;


// const VConsole = new vconsole();

const PREFIX = "HomePage";

type IProps = RouteComponentProps & {
  activity_id: string;
} & ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

interface IState {
  showToast: boolean;
  toastTip: string;
  detail: IActivityInfo;
  showModal: boolean;
  show_status: 0 | 1; // 页面展示状态 0 报名中 1 已报名
  showCertModal: boolean;
  otherModalVisible: boolean;
  otherModalConf: IOtherRewardModalConf | null;
  showRewardModal: boolean;
  enter_info: IEnterList;
  user_info: IUserinfo;
  sportsType: string[];
  /* 是否初始化完成（即第一次调完 模板、我的活动信息 接口） */
  isTempInited: boolean;
  isMyActivityInited: boolean;

  route_list: IRouteListItem[];
  label_info: {
    label_content: string;
    normal_feed_list: IFeedDetailView[];
  };
  complete_count: number;
  selectedGoalNum: number; // 当前所选目标
  sportTypeSelectModalVisible: boolean; // 运动类型选择弹窗
  /* 对赌 */
  isGamblingRegistLoading: boolean; // 加载中，不可二次下单
  gamblingFailModalVisible: boolean; // 失败弹窗
  gamblingSuccessModalVisible: boolean; // 完成，未退费弹窗
  gamblingRefundModalVisible: boolean; // 完成，已退费弹窗

  isSignLoading: boolean; // 报名 loading
  infoModalVisible: boolean; // 填写信息弹窗
  infoModalParams?: {
    required: boolean;
    title: string;
    placeholder: string;
    input_type: string;
    value: string;
    isSkip: boolean;
  };
  // 缓存一下goal_id
  goal_id: number;
  showNewUserRewardModalVisible: boolean; // 新用户大礼包弹窗
}

class Index extends React.Component<IProps, IState> {
  toPayPageLoadingTimer: number | null = null;
  system: null | ReturnType<typeof SystemFun.checkSystemByUserAgent> = null;

  constructor(props: IProps) {
    super(props);
    document.title = "活动详情";
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onPopConfirm = this.onPopConfirm.bind(this);
    this.onShowCertModal = this.onShowCertModal.bind(this);
    this.system = SystemFun.checkSystemByUserAgent();
  }

  public state: IState = {
    showToast: false,
    toastTip: "",
    showModal: false,
    show_status: 0,
    label_info: {
      label_content: "",
      normal_feed_list: [],
    },
    complete_count: 0,
    isTempInited: false,
    isMyActivityInited: false,
    showCertModal: false,
    showRewardModal: false,
    otherModalVisible: false,
    otherModalConf: null,
    route_list: [],
    sportsType: [],
    user_info: {
      id: "",
      nick: "",
      portrait: "",
    },
    enter_info: {
      enter_count: 0,
      avatar_list: [],
    },
    detail: {
      goals: [],
      effect_end: "",
      effect_start: "",
      enter_start: "",
      enter_end: "",
      finish_goal_count: 0,
      type: 0,
    },
    selectedGoalNum: 0,
    sportTypeSelectModalVisible: false,
    /* 对赌 */
    isGamblingRegistLoading: false,
    gamblingFailModalVisible: false,
    gamblingSuccessModalVisible: false,
    gamblingRefundModalVisible: false,

    isSignLoading: false,
    infoModalVisible: false,
    goal_id: 0,
    showNewUserRewardModalVisible: false,
  };

  componentWillMount() {
    this.init();

    /* 处理站外 - 监听页面失焦、获焦 */
    document.onvisibilitychange = () => {
      this.getMyActivity();
    };

    /* 注册从客户端页面返回（如收银台页面）的回调 */
    addNativeReturnListener(() => {
      this.getMyActivity();
    });
  }

  componentDidMount() {
    /**
     * 初始化并监听localStorage
     */
    localStorage.setItem(LOCAL_STORAGE_ADDRESS_KEY, "");
    window.addEventListener("storage", this.localStorageAddressListener);
  }

  componentWillUnmount() {
    this.toPayPageLoadingTimer &&
      window.clearTimeout(this.toPayPageLoadingTimer);
    window.removeEventListener("storage", this.localStorageAddressListener);
    document.onvisibilitychange = null;
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    const { detail } = this.state;
    const { tempDetail } = this.props;
    if (detail !== prevState.detail || tempDetail !== prevProps.tempDetail) {
      if (detail && tempDetail) {
        /* 活动详情、模板详情 都准备好了 */
        this.tryRegistShare(detail, tempDetail);
      }
    }
  }

  /**
   * 初始化页面
   */
  init = async () => {
    /* 先尝试站内免登陆 */
    const login = new Login(axios);
    await login.checkLogin();
    // 站外 getUserInfo 未登录会 401，全局拦截器会跳登录页，故仅站内这里拉
    if (isInCodoon()) {
      this.getUserInfo();
    }
    this.getMyActivity();
    this.getEnterList();
    this.getActivityTemplate();
  };

  // 初始化选中的目标 selectedGoalNum
  initSelectGoalNum = (finishGoalCount: number, goals: IGoal[]) => {
    // 当为单个目标模式，应该永远选中用户报名时选择参加的那一个
    if (finishGoalCount == -1) {
      // 完成单个目标模式，只会有一个目标的progress_id > 0
      const selectedGoalNum = findIndex(goals, (goal) => {
        return goal.progress_id > 0;
      });
      // 不然选中第0个
      return Math.max(selectedGoalNum, 0);
    }

    // 如果有目标在进行，选中进行中的第一个
    const curr = day().valueOf();
    const selectedGoalNum = findIndex(goals, (goal) => {
      const start = day(goal.limit_start, TIME_FORMATTER).valueOf();
      const end = day(goal.limit_end, TIME_FORMATTER).valueOf();
      return start <= curr && curr <= end;
    });
    // 不然选中第0个
    return Math.max(selectedGoalNum, 0);
  };

  localStorageAddressListener = () => {
    const { detail } = this.state;
    const nextAddressStr = localStorage.getItem(LOCAL_STORAGE_ADDRESS_KEY);
    if (nextAddressStr) {
      const nextAddress: IAddressDatum = JSON.parse(nextAddressStr);
      this.setState({
        detail: update(detail, {
          address_info: { $set: nextAddress },
        }),
      });
    }
  };

  public onPopConfirm(): void {
    this.setState({ showModal: false });
  }

  /* 选择报名目标 */
  public onSelectGoal(goal_id: number): void {
    // 关闭弹窗
    this.onPopConfirm();
    this.handleSubmit(null, goal_id);
  }

  public onShowCertModal(show: boolean): void {
    this.setState({ showCertModal: show });
  }

  /**
   * 其它奖励 弹窗
   * 说明：如果是“完成单个目标”的活动，并且是新配的活动，是支持 不同目标 对应 不同弹窗配置 的
   */
  openOtherModal = () => {
    const { tempDetail } = this.props;
    const { detail } = this.state;
    const { reword_list } = tempDetail;

    // 是否是“完成单个目标”的活动
    const isFinishOneGoal = checkIsFinishOneGoal(detail);
    const goals = getGoals(detail);

    // 弹窗内容（也指示了是否弹弹窗）
    let modalConf: IOtherRewardModalConf | null = null;
    let useOldLogic: boolean = false;

    if (isFinishOneGoal) {
      // 是“完成单个目标”的活动
      // 判断模板中，goal_reward_list 字段有没有值，有才走新逻辑，没有还是走老逻辑（兼容以前没配新字段的活动）
      if (isEmpty(reword_list.goal_reward_list)) {
        // 老的活动，没有这个配置项，走老逻辑
        useOldLogic = true;
        modalConf = {
          img: reword_list.pop_up_img || "",
          url: reword_list.reward_url || undefined,
        };
      } else {
        // 走新逻辑，找到完成的是哪一个目标，然后弹这个目标对应的弹窗配置
        const myGoal = findMyGoal(goals);
        // 还要在模板里找，这个目标对应的奖励配置（包括是否限量配置）
        const tempGoalConf = findTempGoalConf(
          reword_list.goal_reward_list,
          myGoal
        );
        if (myGoal && tempGoalConf) {
          // 所选目标、目标配置都找到了，判断是否限量
          if (
            tempGoalConf.limit_count &&
            myGoal.fin_index > tempGoalConf.limit_count
          ) {
            // 有限量的配置 && 已经没有资格了
            showToast("很遗憾您未获奖！感谢您的参与与支持，下次再接再厉！");
            modalConf = null;
          } else {
            // 无限量的配置 || 限量，但还有资格
            // 都可以弹弹窗
            modalConf = {
              img: tempGoalConf.pop_up_img,
              url: tempGoalConf.reward_url || undefined,
            };
          }
        } else {
          // 异常情况：没找到，走老逻辑吧（正常肯定找得到的！）
          useOldLogic = true;
        }
      }
    } else {
      // 不是，走老逻辑
      useOldLogic = true;
    }

    if (useOldLogic) {
      // 老逻辑，用 pop_up_img 字段
      modalConf = {
        img: reword_list.pop_up_img || "",
        url: reword_list.reward_url || undefined,
      };
    }

    if (modalConf) {
      // 弹弹窗
      this.setState({
        otherModalVisible: true,
        otherModalConf: modalConf,
      });
    }
  };
  closeOtherModal = () => {
    // 关闭，即清空
    this.setState({ otherModalVisible: false });
  };

  onShowRewardModal = (show: boolean) => {
    this.setState({ showRewardModal: show });
  };

  onShowNewUserRewardModal = (show: boolean) => {
    // 手动领取奖励
    if (show) {
      this.setState({ showNewUserRewardModalVisible: true });
    } else {
      this.setState({ showNewUserRewardModalVisible: false });
    }
  };

  goMoreAct = () => {
    window.location.href = "https://www.codoon.com/tab/discovery?tab=activity";
  };

  // 获取用户信息
  public getUserInfo(): void {
    indexService
      .getUserInfo()
      .then((response) => {
        console.log("response: ", response);
        if (response.status == "OK") {
          this.setState({ user_info: response.data });
        } else {
          this.toggleShowToast(true, response.description);
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  }

  // 去抽奖
  onLottery = () => {
    const { detail } = this.state;
    if (detail && detail.lottery_url) {
      window.location.href = detail.lottery_url;
    }
  };

  /**
   * 获取活动模版详情
   */
  public getActivityTemplate(): void {
    const { activity_id } = this.props;
    const { isTempInited } = this.state;
    const param = {
      activity_id: parseInt(activity_id),
    };
    indexService.getActivityTemplate(param).then((response) => {
      !isTempInited && this.setState({ isTempInited: true });
      if (response.status == "OK") {
        this.handleTempResolve(response.data);
      } else {
        this.toggleShowToast(true, response.description);
      }
    });
  }

  handleTempResolve = (data: {
    detail: IPostCreateTempDetail;
    medals: IMedalInfo[];
  }) => {
    const { setTempDetail, setMedals } = this.props;

    setTempDetail(data.detail);
    setMedals(data.medals);

    // 处理报名信息表单
    const { sign_up_info } = data.detail;
    if (sign_up_info) {
      const { items } = sign_up_info;
      if (items && items.length > 0) {
        this.setState({
          infoModalParams: {
            ...items[0],
            value: "",
            isSkip: false,
          },
        });
      }
    }

    const { topic } = data.detail;
    topic && topic.show && topic.topic_id && this.getFeedsByLabel(data.detail);
  };

  // 获取话题
  public getFeedsByLabel(tempDetail: IPostCreateTempDetail): void {
    const param = {
      limit: 6,
      label_id: tempDetail.topic.topic_id,
    };
    indexService.getFeedsByLabel(param).then((response) => {
      if (response && response.status == "OK") {
        const { label, normal_feed_list } = response.data;
        this.setState({
          label_info: {
            normal_feed_list,
            label_content: label.label_content,
          },
        });
      } else if (response && response.description) {
        this.toggleShowToast(true, response.description);
      }
    });
  }

  // toast提示
  public toggleShowToast(showToast: boolean, toastTip: string): void {
    this.setState({ showToast, toastTip });
    setTimeout(() => {
      this.setState({ showToast: false, toastTip: "" });
    }, 2000);
  }

  /* 对赌：获取对赌奖金信息 */
  getGamblingCount = async (activityInfo: IActivityInfo) => {
    const { activityId, setGamblingInfo } = this.props;
    if (activityId) {
      try {
        const res = await ActivityApi.getGamblingCount({
          activity_id: activityId,
        });
        if (res.status == "OK") {
          const data = res.data;
          setGamblingInfo(res.data);
          this.initGamblingEndModal(activityInfo, data);
        } else {
          throw Error(res.description);
        }
      } catch (e: any) {
        showToast(`获取奖金信息失败：${e?.message}`);
      }
    }
  };

  /* 对赌：判断是否显示对赌活动结束后的弹窗 */
  initGamblingEndModal = (
    activityInfo: IActivityInfo,
    gamblingInfo: IGetGamblingCountData
  ) => {
    // 是否报名活动
    if (activityInfo.enter_status) {
      // 判断对赌活动是否结束，准备弹出结束弹窗
      const activityEndTimeVal = day(
        activityInfo.effect_end,
        TIME_FORMATTER
      ).valueOf();
      const currTimeVal = day().valueOf();
      if (activityEndTimeVal < currTimeVal) {
        if (activityInfo.enter_status == 1) {
          // 报名、未完成
          this.setState({
            gamblingFailModalVisible: true,
          });
        } else if (activityInfo.enter_status == 2) {
          // 报名、已完成
          if (gamblingInfo.user_refund) {
            // 已退费
            this.setState({
              gamblingRefundModalVisible: true,
            });
          } else {
            // 未退费
            this.setState({
              gamblingSuccessModalVisible: true,
            });
          }
        }
      }
    }
  };

  /**
   * 活动详情、模板详情都准备好时，注册右上角分享
   * 说明：
   * 挑战后台有4处可以配置图片的地方，但3个地方都非正方形，剩余的1个地方（背景图）未限制图片尺寸
   * 故判断，若背景图传的是正方形，用背景图当分享图；如果不是，用原逻辑，模板顶图当分享图
   */
  tryRegistShare = async (
    detail: IActivityInfo,
    tempDetail: IPostCreateTempDetail
  ) => {
    const bgPic = detail.pic_url || "";
    const topPic = tempDetail?.head_img?.img_url || "";

    let sharePic = "";
    // 先判断背景图是否为正方形
    const bgPicInfo = await ImageFun.measureImageByUrl(bgPic);
    if (bgPicInfo.width === bgPicInfo.height) {
      // 是正方形
      sharePic = bgPic;
    } else {
      // 不是
      sharePic = topPic;
    }

    // 注册分享
    shareDefaultTop({
      sCodoonShareImgUrl: sharePic,
      sCodoonShareLineLink: window.location.href,
      sCodoonShareTitle: tempDetail.share_param.title,
      sCodoonShareDescContent: tempDetail.share_param.content,
      sCodoonShareCodoonLineLink: window.location.href,
      oCodoonShareDestination: {
        codoonTimeline: true,
        codoonGroup: true,
        weixinToFriend: true,
        weixinToTimeline: true,
        sinaWeibo: false,
        tencentQQ: true,
        tencentQzone: true,
      },
    });
    wxShareConfig({
      title: tempDetail.share_param.title,
      desc: tempDetail.share_param.content,
      link: window.location.href,
      imgUrl: sharePic,
    });
  };

  /* get_my_activity */
  public getMyActivity(cb?: () => void): void {
    const { activity_id, setActivityInfo, setActivityInfoLoading } = this.props;
    const { isMyActivityInited } = this.state;
    const param = {
      activity_id: parseInt(activity_id),
    };
    let status: 0 | 1 = 0;
    setActivityInfoLoading(true);
    this.loadMyActivity(param)
      .then(({ response, isGuest }) => {
        !isMyActivityInited && this.setState({ isMyActivityInited: true });
        setActivityInfoLoading(false);
        cb?.();
        if (response && response.status == "OK") {
          const data = response.data;
          /* 存入store中 */
          setActivityInfo(data);
          /* 对赌奖金接口需要登录；游客浏览不请求，避免 401 跳登录 */
          if (data.type == 1 && !isGuest) {
            this.getGamblingCount(data);
          }

          /* 设置顶部标题 */
          if (response.data.name) {
            document.title = response.data.name;
          }

          if (!isGuest && response.data.enter_status) {
            this.getRouteList();
            this.getCompleteCount();
          }
          if (response.data.enter_status === 1) {
            status = 1;
          }
          if (response.data.enter_status === 2) {
            status = 1;
          }

          this.setState({
            detail: response.data,
            show_status: status,
            selectedGoalNum: this.initSelectGoalNum(
              response.data.finish_goal_count,
              response.data.goals || []
            ),
          });
        } else if (response && response.description) {
          this.toggleShowToast(true, response.description);
        }
      })
      .catch(() => {
        !isMyActivityInited && this.setState({ isMyActivityInited: true });
        setActivityInfoLoading(false);
      });
  }

  /**
   * 站内走原接口。
   * 站外先探测登录态：已登录用原数据；未登录改走开放接口，页面按报名前展示。
   */
  loadMyActivity = async (param: {
    activity_id: number;
  }): Promise<{
    response: IResponse<IActivityInfo>;
    isGuest: boolean;
  }> => {
    if (!isInCodoon()) {
      try {
        const authed = await ActivityApi.getMyActivityIgnoreAuth(param);
        if (authed && authed.status === "OK") {
          if (!this.state.user_info.id) {
            this.getUserInfo();
          }
          return { response: authed, isGuest: false };
        }
      } catch (e) {
        // 探测失败则走开放接口
      }
      return {
        response: await ActivityApi.getOpenMyActivity(param),
        isGuest: true,
      };
    }
    return {
      response: await ActivityApi.getMyActivity(param),
      isGuest: false,
    };
  };

  // 获取完成活动人数
  public getCompleteCount(): void {
    indexService
      .getCompleteCount({
        activity_id: parseInt(this.props.activity_id),
      })
      .then((response) => {
        if (response.status == "OK") {
          this.setState({ complete_count: response.data.complete_count });
        } else {
          this.toggleShowToast(true, response.description);
        }
      });
  }

  // 获取路线
  public getRouteList(): void {
    indexService
      .getRouteList({
        activity_id: parseInt(this.props.activity_id),
      })
      .then((response) => {
        if (response.status == "OK") {
          const data = response.data || [];
          this.setState({ route_list: data.slice(0, 3) });
        } else {
          this.toggleShowToast(true, response.description);
        }
      });
  }

  // 获取参与人数
  public getEnterList(): void {
    const { activity_id } = this.props;
    indexService
      .getEnterList({
        activity_id: parseInt(activity_id),
      })
      .then((response) => {
        if (response.status == "OK") {
          this.setState({ enter_info: response.data });
        } else {
          this.toggleShowToast(true, response.description);
        }
      });
  }

  // 提交报名 点击立即报名
  public handleSubmit(e: any, goal_id?: number): void {
    const { activity_id } = this.props;
    const { detail } = this.state;
    const params: IUserCenterParams = {
      activity_id: parseInt(activity_id),
    };

    // 如果是单一活动, 需要选择对应的目标
    if (detail.enter_type == 1 && !goal_id) {
      // 显示弹选择目标报名弹窗
      this.setState({ showModal: true });
      return;
    } else if (goal_id) {
      params.goal_id = goal_id;
      this.setState({ goal_id: goal_id });
    }

    // 在这里判断是否需要填写信息
    const infoForm = this.state.infoModalParams;

    if (infoForm) {
      // 如果是必填，并且没有填写，就弹窗
      if (infoForm.required) {
        if (!infoForm.value) {
          this.setState({
            infoModalVisible: true,
            infoModalParams: {
              ...infoForm,
              value: "",
              isSkip: false,
            },
          });
          return;
        }
      } else {
        // 如果不是必填，并且不是跳过，就说明从没有弹出过
        if (!infoForm.isSkip && !infoForm.value) {
          this.setState({
            infoModalVisible: true,
            infoModalParams: {
              ...infoForm,
              value: "",
              isSkip: false,
            },
          });
          return;
        }
      }
      params.sign_up_items = [
        {
          title: infoForm.title,
          value: infoForm.value,
        },
      ];
    }

    if (detail.type == 2) {
      // 如果是商品促销类型 则需要跳转报名套餐页面 不走下面流程
      const url = `/activity/club/signGroup?activityId=${activity_id}&goalId=${goal_id ? goal_id : ""
        }`;
      window.history.pushState({ title: "title", url: url }, "", url);
      window.location.reload();
      return;
    }

    this.postUserEnter(params);
  }

  /* 对赌报名（支付下单这种，防抖要做好）*/
  handleGamblingRegist = async () => {
    if (!isInCodoon()) {
      // 唤醒咕咚个并进入当前活动页
      openCodoon(window.location.origin + window.location.pathname, "h5");
    } else {
      // 站内才能对赌报名
      const { activityId, gamblingPrice } = this.props;
      const { isGamblingRegistLoading } = this.state;
      if (!isGamblingRegistLoading && activityId) {
        this.setState({
          isGamblingRegistLoading: true,
        });
        try {
          const res = await ActivityApi.gamblingRegist({
            activity_id: activityId,
            price: gamblingPrice,
          });
          if (res.status == "OK") {
            const orderId = res.data.order_id;
            // 前往收银台页面
            window.location.href = `//www.codoon.com/mall/pay_checkstand?order_id=${orderId}`;
            // 打开客户端收银台页面，会有延迟，此时如果loading结束，会导致可重复点击按钮
            // 故loading多转2s，保证收银台页面完全打开
            this.toPayPageLoadingTimer = window.setTimeout(() => {
              this.setState({
                isGamblingRegistLoading: false,
              });
            }, 2000);
          } else {
            throw Error(res.description);
          }
        } catch (e: any) {
          this.setState({
            isGamblingRegistLoading: false,
          });
          showToast(`报名失败：${e.message}`);
        }
      }
    }
  };
  debounceHandleGamblingRegist = FunctionFun.debounce(
    this.handleGamblingRegist,
    300
  );

  public postUserEnter(params: IUserCenterParams): void {
    this.setState({ isSignLoading: true });
    indexService.postUserEnter(params).then((response) => {
      this.setState({ isSignLoading: false });
      if (response.status == "OK") {
        this.getMyActivity(() => {
          showToast("报名成功");
        });
      } else {
        this.toggleShowToast(true, response.description);
      }
    });
  }

  // 查看活动详情
  handleViewDetail = () => {
    this.setState({ show_status: 0 });
  };

  // 选择目标
  handleSelectGoal = (nextGoalNum: number) => {
    this.setState({
      selectedGoalNum: nextGoalNum,
    });
  };

  // 点击【马上开始】按钮
  handleStartBtnClick = () => {
    if (this.system && this.system.isCodoon) {
      // 如果在咕咚内
      const { selectedGoalNum, detail } = this.state;
      const sportTypeInfos = this.getCurrGoalSportTypeInfos(
        detail,
        selectedGoalNum
      );
      console.log("10.sportTypeInfos", sportTypeInfos);
      if (sportTypeInfos.length == 1) {
        // 如果只有一种运动类型，则直接跳转到该类型对应的运动页
        window.open(sportTypeInfos[0].jumpUrl, "_blank");
      } else {
        // 否则打开运动类型选择弹窗
        this.toggleSportTypeSelectModal();
      }
    } else {
      // 唤醒咕咚个并进入当前活动页
      openCodoon(window.location.origin + window.location.pathname, "h5");
    }
  };

  /**
   * 打开运动类型选择弹窗
   */
  toggleSportTypeSelectModal = () => {
    const { sportTypeSelectModalVisible } = this.state;
    this.setState({
      sportTypeSelectModalVisible: !sportTypeSelectModalVisible,
    });
  };

  /**
   * 获取当前目标
   */
  getCurrGoal = memoizeOne(
    (activityInfo: IActivityInfo, selectedGoalNum: number): IGoal | null => {
      return activityInfo.goals[selectedGoalNum] || null;
    }
  );

  /**
   * 获取当前目标的运动类型
   */
  getCurrGoalSportTypeInfos = memoizeOne(
    (
      activityInfo: IActivityInfo,
      selectedGoalNum: number
    ): ISportTypeInfo[] => {
      const currGoal = this.getCurrGoal(activityInfo, selectedGoalNum);
      if (currGoal) {
        const sportTypes = currGoal.sports_type.split(",") as ISportType[];
        const sportTypeInfos = map(sportTypes, (sportType): ISportTypeInfo => {
          let jumpUrl = "";
          if (
            sportType == "0" ||
            sportType == "1" ||
            sportType == "2" ||
            sportType == "3" ||
            sportType == "4" ||
            sportType == "5"
          ) {
            jumpUrl = `codoon://www.codoon.com/sport/${this.system && this.system.isAndroid ? "preview" : "preview_goal"
              }?sportType=${sportType}`;
          } else if (sportType == "101") {
            jumpUrl = currGoal.class_url;
          } else if (sportType == "102") {
            jumpUrl = currGoal.step_url;
          }
          return {
            sportType,
            jumpUrl,
          };
        });
        return sportTypeInfos;
      }
      return [];
    }
  );

  /**
   * 从介绍页回到进行中页面
   */
  handleViewProgress = () => {
    this.setState({ show_status: 1 });
  };

  /**
   * 对赌：失败弹窗
   */
  toggleGamblingFailModal = () => {
    const { gamblingFailModalVisible } = this.state;
    this.setState({
      gamblingFailModalVisible: !gamblingFailModalVisible,
    });
  };
  /**
   * 对赌：完成弹窗
   */
  toggleGamblingSuccessModal = () => {
    const { gamblingSuccessModalVisible } = this.state;
    this.setState({
      gamblingSuccessModalVisible: !gamblingSuccessModalVisible,
    });
  };
  /**
   * 对赌：退费弹窗
   */
  toggleGamblingRefundModal = () => {
    const { gamblingRefundModalVisible } = this.state;
    this.setState({
      gamblingRefundModalVisible: !gamblingRefundModalVisible,
    });
  };

  // 报名后页显示文案
  comBtnValue = () => {
    const { detail } = this.state;
    const currTime = day();

    if (!detail) {
      return null;
    }

    const currTimeVal = currTime.valueOf();
    // 活动时间
    const activityStartTimeVal = day(
      detail.effect_start,
      TIME_FORMATTER
    ).valueOf();
    const activityEndTimeVal = day(detail.effect_end, TIME_FORMATTER).valueOf();

    // 报名了后显示该文案  enter_status： 1 未报名  2：已完成
    // 活动未开始 + 活动进行时间内
    if (
      currTimeVal < activityStartTimeVal ||
      (activityStartTimeVal <= currTimeVal &&
        currTimeVal <= activityEndTimeVal &&
        detail.enter_status != 2)
    ) {
      return "完成挑战后将赢得";
    }

    // 活动进行时间内 + 活动结束
    if (
      ((activityStartTimeVal <= currTimeVal &&
        currTimeVal <= activityEndTimeVal) ||
        activityEndTimeVal < currTimeVal) &&
      detail.enter_status == 2
    ) {
      // 已完成
      return "祝贺你赢得";
    }

    // 活动结束
    if (activityEndTimeVal < currTimeVal) {
      return "很遗憾未能赢得";
    }
  };

  getIsLoading = () => {
    const { isGamblingRegistLoading, isSignLoading } = this.state;
    const { activityInfoLoading } = this.props;
    return isGamblingRegistLoading || isSignLoading || activityInfoLoading;
  };

  render() {
    const {
      detail,
      enter_info,
      showModal,
      showCertModal,
      otherModalVisible,
      otherModalConf,
      showRewardModal,
      route_list,
      selectedGoalNum,
      sportTypeSelectModalVisible,
      gamblingFailModalVisible,
      gamblingSuccessModalVisible,
      gamblingRefundModalVisible,
      complete_count,
      isTempInited,
      isMyActivityInited,
      infoModalVisible,
      showNewUserRewardModalVisible
    } = this.state;
    const { isGambling, activity_id, tempDetail, medals } = this.props;

    /* 第一次调接口未完成，不会进入页面 */
    if (!isTempInited || !isMyActivityInited) {
      return <GlobalLoading isLoading={true} noBgColor={true} />;
    }

    const sportTypeInfos = this.getCurrGoalSportTypeInfos(
      detail,
      selectedGoalNum
    );

    /**
     * 是否配置了颜色
     * 若是，则文字要变成白色主题
     */
    const isCustomColor: boolean = !!(
      tempDetail.card_info &&
      (tempDetail.card_info.card_color || tempDetail.card_info.card_bg_color)
    );

    /* 是否为报名页 */
    const isSignPage = !this.state.show_status;
    // 页面展示状态 0 报名中 1 已报名
    const { reword_list } = tempDetail;
    const { reward_url } = reword_list;
    const { user_info } = this.state;
    const url = `${reward_url}${encodeURIComponent(user_info.id)}`;

    const isLoading = this.getIsLoading();

    return (
      <div
        className={classNames(PREFIX, {
          "is-iosBangsDevice": isIosBangsDevice,
        })}
      >
        {this.state.showToast && <GlobalToast text={this.state.toastTip} />}
        {/** 头部封面 */}
        <div
          className={`${PREFIX}-header`}
          style={{
            // 开通前才根据配置修改背景颜色
            backgroundColor:
              (isSignPage &&
                tempDetail.card_info &&
                tempDetail.card_info.card_bg_color) ||
              "white",
          }}
        >
          <img
            className={`${PREFIX}-headerImg`}
            src={tempDetail.head_img.img_url}
          />
          {isSignPage ? (
            <ActivityInfoCard
              activityInfo={detail}
              tempInfo={tempDetail}
              enter_info={enter_info}
              whiteThemeEnable={isCustomColor}
              onViewProgress={this.handleViewProgress}
            />
          ) : (
            <ProgressCard
              activityInfo={detail}
              onViewDetail={this.handleViewDetail}
              selectedGoalNum={selectedGoalNum}
              onSelectGoal={this.handleSelectGoal}
            />
          )}
        </div>

        <div>
          {/* 报名前的模块 */}
          {/** 活动介绍 */}
          {tempDetail.activity_intro.show && isSignPage ? (
            <ClubActivityRule detail={tempDetail.activity_intro} />
          ) : null}
          {/** 活动规则 */}
          {tempDetail.rule_info.show && isSignPage ? (
            <ClubActivityRule detail={tempDetail.rule_info} />
          ) : null}
          {/** 报名前活动奖励 */}
          {isSignPage ? <SignRewardModule tempDetail={tempDetail} /> : null}

          {/* 商品促销类型 报名后的模块 */}
          {/* 商品促销类型 - 完成后奖励展示 */}
          {!isSignPage && detail.type == 2 && detail.enter_status ? (
            <div className={"PromotionReward-card"}>
              <div className={"pic"}>
                <img src={detail?.user_goods_suit?.pic} />
              </div>
              <div className={"desc"}>
                {this.comBtnValue()}
                <span>{detail?.user_goods_suit?.award_desc}</span>
              </div>
            </div>
          ) : (
            ""
          )}

          {/* 进行中页面的模块 */}
          {/* 对赌：奖金模块 */}
          {!isSignPage && isGambling ? <GamblingPriceModule /> : null}
          {/** 进行页活动介绍 */}
          {!isSignPage &&
            tempDetail.act_intro_ing &&
            tempDetail.act_intro_ing.show ? (
            <ClubActivityRule detail={tempDetail.activity_intro} />
          ) : null}
          {/** 报名后运动记录 */}
          {tempDetail.sports_record.show && !isSignPage && route_list.length ? (
            <ClubActivitySportRecord
              applyTime={detail.user_enter_time || ""}
              route_list={route_list}
              actId={Number(this.props.activity_id)}
            />
          ) : null}
          {/** 报名后活动奖励 */}
          {!isSignPage ? (
            <ProgressRewardModule
              tempDetail={tempDetail}
              medals={medals}
              completeCount={complete_count}
            />
          ) : null}

          {/* 报名前后都有的模块 */}
          {/** 参与话题 */}
          {tempDetail.topic.show ? (
            <ClubActivityTopic
              detail={tempDetail.topic}
              label_info={this.state.label_info}
            />
          ) : null}
        </div>

        {/** 单一目标选择弹框 */}
        <Modal visible={showModal} animation="none" onClose={this.onPopConfirm}>
          <ClubActivityGoal
            goals={detail.goals}
            onSelectGoal={this.onSelectGoal.bind(this)}
          />
        </Modal>

        {/** 运动类型选择二级弹框 */}
        <Modal
          visible={sportTypeSelectModalVisible}
          animation="none"
          onClose={() => {
            this.setState({ sportTypeSelectModalVisible: false });
          }}
        >
          <SportTypeSelector
            sportTypeInfos={sportTypeInfos}
            onClose={() => {
              this.setState({ sportTypeSelectModalVisible: false });
            }}
          />
        </Modal>

        {/* 其它奖励弹窗 */}
        <OtherRewardModal
          visible={otherModalVisible}
          conf={otherModalConf}
          onClose={this.closeOtherModal}
          activity_id={activity_id}
          user_info={this.state.user_info}
        />

        {/** 证书弹框 */}
        <Modal
          visible={showCertModal}
          animation="fade"
          style={styles.certModalContent}
          onClose={() => this.onShowCertModal(false)}
        >
          <ClubActivityCertModal
            user_info={this.state.user_info}
            name={detail.name}
            onClose={() => this.onShowCertModal(false)}
            tempDetail={tempDetail}
            activity_id={activity_id}
          />
        </Modal>

        {/* 实物、虚拟奖励弹窗 */}
        <RewardModal
          visible={showRewardModal}
          onClose={() => this.onShowRewardModal(false)}
          activityDetail={detail}
          tempDetail={tempDetail}
        />

        {/* 对赌：挑战失败弹窗 */}
        <GamblingFailModal
          visible={gamblingFailModalVisible}
          onClose={this.toggleGamblingFailModal}
        />
        {/* 对赌：成功、还未退费弹窗 */}
        <GamblingSuccessModal
          visible={gamblingSuccessModalVisible}
          onClose={this.toggleGamblingSuccessModal}
        />
        {/* 对赌：成功、已退费弹窗 */}
        <GamblingRefundModal
          visible={gamblingRefundModalVisible}
          onClose={this.toggleGamblingRefundModal}
        />
        {/* 新人大礼包弹窗 */}
        {detail.special_flag === 1 &&
          <NewUserRewardModal
            visible={showNewUserRewardModalVisible}
            onClose={() => this.onShowNewUserRewardModal(false)}
            activityDetail={detail}
            tempDetail={tempDetail}
            user_info={this.state.user_info}
          />}

        {/** 底部按钮 */}
        {detail.activity_id && tempDetail.head_img.img_url && (
          <FooterBtn
            selectedGoalNum={selectedGoalNum}
            onStartBtnClick={this.handleStartBtnClick}
            onGamblingRegist={this.debounceHandleGamblingRegist}
            isSignPage={isSignPage}
            handleSubmit={this.handleSubmit}
            onShowCertModal={this.onShowCertModal}
            onShowOtherModal={this.openOtherModal}
            onShowRewardModal={this.onShowRewardModal}
            rewordList={tempDetail.reword_list}
            onLottery={this.onLottery}
            activity_id={activity_id}
            goMoreAct={this.goMoreAct}
            onShowNewUserRewardModal={this.onShowNewUserRewardModal}
          />
        )}

        {/* 填写信息弹窗 */}
        <InfoModal
          visible={infoModalVisible}
          value={this.state.infoModalParams}
          onSubmit={(value) => {
            this.setState(
              {
                infoModalParams: {
                  ...value,
                  isSkip: false,
                },
                infoModalVisible: false,
              },
              () => {
                // 继续提交
                this.handleSubmit(null, this.state.goal_id);
              }
            );
          }}
          onSkip={() => {
            this.setState(
              {
                infoModalParams: {
                  ...this.state.infoModalParams!,
                  isSkip: true,
                },
                infoModalVisible: false,
              },
              () => {
                // 继续提交
                this.handleSubmit(null, this.state.goal_id);
              }
            );
          }}
          onClose={() => {
            this.setState({ infoModalVisible: false });
          }}
        />

        {/* loading */}
        <GlobalLoading isLoading={isLoading} delay={100} />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    activityInfo: activityInfoSelector(state),
    activityInfoLoading: activityInfoLoadingSelector(state),
    isGambling: isGamblingSelector(state),
    activityId: activityIdSelector(state),
    gamblingPrice: gamblingPriceSelector(state),
    tempDetail: tempDetailSelector(state),
    medals: medalsSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    setActivityInfo: (data: IActivityInfo) => {
      dispatch(setActivityInfoAction(data));
    },
    setActivityInfoLoading: (data: boolean) => {
      dispatch(setActivityInfoLoadingAction(data));
    },
    setGamblingInfo: (data: IGetGamblingCountData) => {
      dispatch(setGamblingInfoAction(data));
    },
    setTempDetail: (data: IPostCreateTempDetail) => {
      dispatch(setTempDetailAction(data));
    },
    setMedals: (data: IMedalInfo[]) => {
      dispatch(setMedalsAction(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
